import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialIndoorManagementState from './indoor-management-initial-state';
import { Floor } from '../models/indoor-management';
import { IndoorFloor } from '../../../indoor-maps/models/indoor-maps.model';

const indoorManagementSlice = createSlice({
    name: 'indoorManagementSlice',
    initialState: initialIndoorManagementState,
    reducers: {
        setSelectedCompany(state, { payload }: PayloadAction<string>) {
            state.selectedCompany = payload;
        },
        setSelectedFloors(state, { payload }: PayloadAction<Floor[]>) {
            state.floors = payload;
        },
        setSelectedFloor(state, { payload }: PayloadAction<Floor | null>) {
            state.selectedFloor = payload;
        },
        setIndoorFloors(state, { payload }: PayloadAction<IndoorFloor[]>) {
            state.indoorFloors = payload;
        }
    }
});

export const {
    setSelectedCompany,
    setSelectedFloors,
    setSelectedFloor,
    setIndoorFloors
} = indoorManagementSlice.actions

export default indoorManagementSlice.reducer